import { Pipe, PipeTransform } from "@angular/core";

import { Dates } from "@salaxy/core";

/**
 * Provides a pipe that prints either one date, or a date range
 * from two dates
 */
@Pipe({name: "salaxyDate"})
export class SalaxyDatePipe implements PipeTransform {

    /**
     * The Transform method that implements the Pipe
     * @param startDate - First date to be formatted.
     * @param endDate - Second date to be formatted. If exists, we print a date range.
     */
    public transform(startDate: any, endDate: any): any {
        return Dates.getFormattedDate(startDate, endDate);
    }
}
